import classNames from 'clsx';
import React from 'react';

import StarsButton from '@swf/components/StarsButton/StarsButton';
import type { NavigationTab, SetOnboardingFlowStep } from '@swf/poker';

import AnimatedButton from '../../AnimatedButton/AnimatedButton';

import styles from './NavTab.scss';

export interface NavTabProps<T extends string> {
  navTab: NavigationTab<T>;
  isFirstChild: boolean;
  infoRef?: SetOnboardingFlowStep;
  navClassName?: string;
}

const NavTab = <T extends string>({
  navTab,
  isFirstChild,
  infoRef,
  navClassName,
  ...navTabProps
}: NavTabProps<T>) => (
  <li key={navTab.tabName} className={styles.list}>
    <a
      className={classNames(styles.anchor, navClassName, {
        [styles.buttonAnimation]: navTab.animation,
        [styles[navTab.animationStyle as keyof typeof styles]]: navTab.animationStyle
      })}
      href={`#${navTab.tabName}`}
      onClick={(e) => {
        e.preventDefault();
      }}
      ref={isFirstChild && infoRef ? infoRef : null}
    >
      {navTab.animation ? (
        <AnimatedButton animation={navTab.animation} {...navTabProps} />
      ) : (
        <StarsButton variant="text" {...navTabProps} />
      )}
    </a>
  </li>
);

export default NavTab;
